import { ApiBaseParams } from './_base';

const searchAutocompleteApi = import.meta.env.VITE_APP_API_SEARCH_AUTOCOMPLETE;

export const searchAutocomplete = async (params: ApiBaseParams) => {
  const apiUrl = params.url || searchAutocompleteApi;

  return window.kfApi.getAsync(apiUrl, params.data);
};
